// @flow
import JQueryView, { on } from '../../common/JQueryView';

declare var $: any;

export default class ConfirmationView extends JQueryView {
  constructor() {
    super('.confirmation');
    this.render();
  }

  @on({ event: 'change', selector: '.custom-control-input' })
  onChangeCheckbox() {
    if ($('.custom-control-input[type=checkbox]:not(:checked)').length == 0) {
      $('.form-footer .btn-primary').removeClass('disabled');
    } else {
      $('.form-footer .btn-primary').addClass('disabled');
    }
  }

  render() {
    $('.form-footer .btn-primary').addClass('disabled');
  }
}
